import React from "react"
import "./frames.css"

const SistemaAirBreak = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Sistema Air Break: Eficacia y Seguridad en Terapia Hiperbárica
      </h1>

      <h2 className="frames-subtitle">
        Tecnología Avanzada para Tratamientos Efectivos
      </h2>
      <p className="frames-text">
        Una de las características que distingue a las cámaras hiperbáricas de
        Perry Baromedical es la inclusión del Sistema de Air Break. Este
        elemento tecnológico se encuentra ausente en muchas cámaras monoplaza en
        el mercado, lo que resalta el compromiso de Perry con la eficacia y
        seguridad en la terapia hiperbárica.
      </p>

      <h2 className="frames-subtitle">Componentes y Compatibilidad</h2>

      <h2 className="frames-subsection">Componentes Incluidos</h2>
      <p className="frames-text">
        El sistema Air Break incluye varios componentes clave:
      </p>
      <ul className="frames-text">
        <li>Válvula de demanda</li>
        <li>Accesorios penetradores</li>
        <li>Mangueras internas y externas</li>
        <li>Dos máscaras reutilizables</li>
      </ul>

      <h2 className="frames-subsection">Versiones y Opciones de Mascarillas</h2>
      <p className="frames-text">Disponible en dos versiones:</p>
      <ul className="frames-text">
        <li>Válvula a demanda</li>
        <li>Flujo continuo</li>
      </ul>
      <p className="frames-text">Dos opciones de Mascarillas:</p>
      <ul className="frames-text">
        <li>De silicona reutilizables</li>
        <li>Desechables</li>
      </ul>

      <h2 className="frames-subsection">Compatibilidad Universal</h2>
      <p className="frames-text">
        Este sistema es completamente compatible con todos los modelos de
        cámaras hiperbáricas monoplaza de Perry, convirtiéndolo en un accesorio
        esencial para cualquier configuración de tratamiento.
      </p>

      <h2 className="frames-subtitle">Funcionamiento del Sistema</h2>
      <p className="frames-text">
        Durante una sesión de terapia hiperbárica, el uso de la máscara con
        flujo de aire se limita a unos minutos, permitiendo al paciente respirar
        sin mascarilla el resto del tiempo. Esta característica añade una capa
        extra de comodidad al tratamiento.
      </p>

      <p className="frames-text">
        El sistema Air Break no es solo un complemento de lujo, sino una
        herramienta indispensable para realizar tratamientos hiperbáricos de
        forma efectiva y segura. Con la incorporación de este sistema avanzado,
        Perry Baromedical demuestra su liderazgo en tecnología de terapia
        hiperbárica.
      </p>
    </div>
  )
}

export default SistemaAirBreak
